import { render } from "./room-create.vue?vue&type=template&id=e82abea6"
import script from "./room-create.vue?vue&type=script&lang=js"
export * from "./room-create.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__